var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_230_10004",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 82
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H82V82H0V0Z",
    className: "baseColor2Fill"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_230_10004)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1663 41.0004C75.1663 22.1303 59.8701 6.83414 41 6.83414C22.1299 6.83414 6.83414 22.1303 6.83414 41.0004C6.83414 59.8705 22.1299 75.1667 41 75.1667C59.8701 75.1667 75.1663 59.8705 75.1663 41.0004ZM0 41C0 18.3562 18.3566 0 41 0C63.6438 0 82 18.3562 82 41C82 63.6438 63.6438 82 41 82C18.3566 82 0 63.6438 0 41ZM45.8323 41L56.7078 51.8755C58.0398 53.208 58.0475 55.3605 56.7042 56.7042C55.3698 58.0382 53.2068 58.0386 51.8751 56.7078L41 45.8323L30.1249 56.7078C28.792 58.0398 26.6399 58.0479 25.2958 56.7042C23.9622 55.3698 23.9614 53.2072 25.2922 51.8755L36.1677 41L25.2922 30.1249C23.9602 28.792 23.9525 26.6395 25.2958 25.2962C26.6302 23.9622 28.7932 23.9618 30.1249 25.2926L41 36.1677L51.8751 25.2926C53.208 23.9606 55.3601 23.9525 56.7042 25.2962C58.0378 26.6306 58.0386 28.7932 56.7078 30.1249L45.8323 41Z",
    className: "color4Fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.638b74e6361452c73f9f8b94a876dfdc.svg";
export { ForwardRef as ReactComponent };